/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SendVerificationCode } from '../models/SendVerificationCode';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FaService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * An endpoint for sending a verification code to a phone number.
     * @returns SendVerificationCode
     * @throws ApiError
     */
    public faSendVerificationCodeCreate({
        requestBody,
    }: {
        requestBody: SendVerificationCode,
    }): CancelablePromise<SendVerificationCode> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/2fa/send-verification-code/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
